<script setup>
/** Empty dock body: one short line and a "+ Add" text button. */
defineProps({
	text: { type: String, required: true },
	actionLabel: { type: String, default: '' },
	/** Why adding is not possible right now; hides the action. */
	disabledReason: { type: String, default: '' },
	testid: { type: String, default: '' },
})
const emit = defineEmits(['add'])
</script>

<template>
	<div class="flex flex-col items-center gap-1.5 px-3 py-6 text-center" :data-testid="testid || undefined">
		<p class="m-0 text-xs text-surface-8">{{ text }}</p>
		<button
			v-if="actionLabel && !disabledReason"
			type="button"
			class="rounded px-1.5 py-0.5 text-xs font-medium text-main-light transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-main"
			@click="emit('add')"
		>+ {{ actionLabel }}</button>
		<p v-else-if="disabledReason" class="m-0 text-[0.7rem] text-surface-7">{{ disabledReason }}</p>
	</div>
</template>
